import { render, staticRenderFns } from "./AccountantInfoModal.vue?vue&type=template&id=72a158ee&scoped=true&"
import script from "./AccountantInfoModal.vue?vue&type=script&lang=js&"
export * from "./AccountantInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a158ee",
  null
  
)

export default component.exports